/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 10:51:33
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';
import { FONT_FAMILY } from '../visualConfig';
import { toVisualThousands } from '../utils';

const border = '1px solid #000';
class P16 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    return tableColumns.map(({ children, ...item }) => {
      return {
        ...item,
        ...(Array.isArray(children) && {children: this.fillColor(children)}),
        style: {
          ...item.style,
          fontSize: 0,
          height: 0,
          borderRight: border,
        },
        colStyle: (_, ii, i) => {
          return {
            ...item.colStyle,
            fontSize: 10,
            fontWeight: i === 0 ? 600: 500,
            textAlign: 'center',
            borderRight: i % 7 === 0 ? '2px solid #000' : border,
            borderBottom: border,
            background: '#fff',
            fontFamily: FONT_FAMILY,
          }
        },
        render: (value) => {
          if(/\d/.test(value)) {
            return toVisualThousands(value);
          }
          return value;
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;

    return (
      <Stage>
        <Title4 pageNumber="3.7">安踏VS竞品 | 各圈层主要KOL合作对比</Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
            耐克表现最优，安踏、李宁和阿迪达斯旗鼓相当，斐乐在各圈层的发力均较小
            </div>
            <div contentEditable className={s.des}>
            监测期内，安踏与运动用品行业类和体育赛事类的KOL账号合作较多，其次是跑步和测评种草类的KOL。其中，与运动用品类KOL合作的传播效果最好。竞品中，耐克在五类圈层人群的口碑表现都是第一，用户的自发传播为品牌赢得曝光。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{
                    borderTop: border,
                    borderLeft: border,
                  }}
                />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P16);



// WEBPACK FOOTER //
// src/routes/visualChart/P16/index.js